import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, ColumnLayout, FormField, Link, Modal, Select, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale/es';
import Favorites from '../../../../../components/extras/Favorites';
import TableMovements from '../../../../../components/tables/tableMovements';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemsMovement } from '../../../../../resources/types';
import { buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setLoading, setParameters } from '../../../../commons/functions';



export const ReportsFinanceTransfersChargesPage = () => {
  const { data, menu, parameters } = useGlobalState();
  const [transfers, setTransfers] = useState<any[]>();
  const [years, setYears] = useState<any[]>([]);
  const [movements, setMovements] = useState<ItemsMovement[]>([]);
  const [filter, setFilter] = useState<any>();
  const mountedRef = useRef(false);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id) {
        if (!mountedRef.current) {
          //handleRefresh();
          mountedRef.current = true;
        }
        //handleGetUser(parseInt(id))
      } else {
        //setUser(undefined)
        //handleRefresh();
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  const [users, setUsers] = useState<any[]>([]);
  const [filterValue, setFilterValue] = useState("");



  const handleYears = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/movements/years',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({})
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.movements) {
        setYears(data.movements.map((item: any) => ({
          label: item.year.toString(),
          value: item.year.toString(),
        })));
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleMovements = async () => {
    try {
      setMovements([]);
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/movements/list',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify(filter)
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.movements) {
        setMovements(data.movements);
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!!filter)
      handleMovements();
  }, [filter]);

  const handleRefresh = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/reports/finance/transfers.charges',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({ year: parameters.year })
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.transfers) {
        setTransfers(pivotData(data.transfers))
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const pivotData = (data: any) => {
    // First, group by month
    const grouped = data.reduce((acc: any, item: any) => {
      if (!acc[item.month]) {
        acc[item.month] = {
          month: item.month,
          subtotal: 0,
          accumulated: 0
        };
      }

      // Add the dynamic ID key
      acc[item.month][`k${item.idaccountPlan}`] = item.total;

      // Calculate subtotal
      acc[item.month].subtotal += item.total;
      return acc;
    }, {});

    // Calculate accumulated
    let runningTotal = 0;
    return Object.values(grouped).map((group: any) => {
      runningTotal += group.subtotal;
      return { ...group, accumulated: runningTotal };
    });
  };
  useEffect(() => {
    handleYears();
  }, []);
  const totalAmount = movements.reduce((sum, item) => sum + (Number(item.ammount) || 0), 0);
  const totalCPS = movements.reduce((sum, item) => sum + (Number(item.ammount) * Number(item.transferCPS) || 0), 0);
  return (
    <CustomAppLayout
      toolsHide
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>Transferencias CPV a CPS</Header>
          <Table header={"Traansferencia de cargos efectuados en CPV a CPS"}
            variant='embedded'
            filter={
              <SpaceBetween direction="horizontal" size="xs">
                <FormField label="Filtro anual">
                  <Select
                    loadingText="Cargando años..."
                    options={years}
                    selectedOption={years.find(y => y.value.toString() === parameters.year.toString()) || null}
                    onChange={({ detail }) => {
                      setParameters({
                        ...parameters,
                        year: Number(detail.selectedOption.value)
                      });
                    }}
                  />
                </FormField>
                <FormField label="&nbsp;">
                  <Button style={{ root: btnIconForm }}
                    disabled={years.length === 0}
                    onClick={() => handleRefresh()}><Icon path={mdiMagnify} size={1} /></Button>
                </FormField>
              </SpaceBetween>

            }

            columnDefinitions={[

              {
                id: "month", header: "Mes", cell: (item: any) => {
                  const monthName = format(new Date(parameters.year, item.month - 1, 1), 'MMMM', { locale: es });
                  return monthName.charAt(0).toUpperCase() + monthName.slice(1);

                },
              },

              {
                id: "2224152", header: "ARR VIT", cell: (item: any) =>
                  <Link onClick={() => {
                    setFilter({
                      columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName,idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK, idFlight, receipt, transferCPS, transferCPV",
                      month: item.month,
                      year: parameters.year,
                      idAccountPlan: 2224152,
                      orderBy: "displayName",
                      order: "asc",
                      limit: -1
                    })
                  }}>{formatCurrency(item.k2224152, "CLP")}</Link>
              },
              {
                id: "1433314", header: "CS CPS", cell: (item: any) =>
                  <Link onClick={() => {
                    setFilter({
                      columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName,idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK, idFlight, receipt, transferCPS, transferCPV",
                      month: item.month,
                      year: parameters.year,
                      idAccountPlan: 1433314,
                      orderBy: "displayName",
                      order: "asc",
                      limit: -1
                    })
                  }}>{formatCurrency(item.k1433314, "CLP")}</Link>
              },
              {
                id: "83025", header: "HNG VIT", cell: (item: any) =>
                  <Link onClick={() => {
                    setFilter({
                      columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName,idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK, idFlight, receipt, transferCPS, transferCPV",
                      month: item.month,
                      year: parameters.year,
                      idAccountPlan: 83025,
                      orderBy: "displayName",
                      order: "asc",
                      limit: -1
                    })
                  }}>{formatCurrency(item.k83025, "CLP")}</Link>
              },
              { id: "subtotal", header: "Subtotal", cell: (item: any) => formatCurrency(item.subtotal, "CLP") },
              { id: "accumulated", header: "Acumulado", cell: (item: any) => formatCurrency(item.accumulated, "CLP") },
            ]}
            items={transfers || []}
          />
          {!!filter && !!movements && (
            <Modal size="max" visible={!!filter && !!movements} onDismiss={() => {
              setFilter(undefined)
              setMovements([]);
            }}>
              <TableMovements dateFilter="NONE" excel showPayment={false} movements={movements} visible={true} />
              {movements.length > 0 && (
                <ColumnLayout columns={2}>
                  <FormField label="Total">
                    <Box variant="awsui-value-large">
                      {formatCurrency(totalAmount, "CLP")}
                    </Box>
                  </FormField>
                  <FormField label="Total CPS">
                    <Box variant="awsui-value-large">
                      {formatCurrency(totalCPS, "CLP")}
                    </Box>
                  </FormField>
                </ColumnLayout>
              )}
            </Modal>
          )}
        </SpaceBetween>
      }
    />
  );
};
